import { render, staticRenderFns } from "./SmplEditPrcs.vue?vue&type=template&id=47990aae&scoped=true&"
import script from "./SmplEditPrcs.vue?vue&type=script&lang=js&"
export * from "./SmplEditPrcs.vue?vue&type=script&lang=js&"
import style0 from "./SmplEditPrcs.vue?vue&type=style&index=0&id=47990aae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47990aae",
  null
  
)

export default component.exports